














































import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class Menu extends Vue {
  @Prop(Boolean)
  readonly noIndex!: boolean

  title: string = "Johnny Coach's"
  subtitle: string = 'Paris Personal Trainer'
  menu: Array<object> = [
    {
      path: '/home',
      name: 'home',
      icon: ['fas', 'home'],
    },
    {
      path: '/about',
      name: 'about',
      icon: ['fas', 'calendar-times'],
    },
    {
      path: '/training',
      name: 'training',
      icon: ['fas', 'dumbbell'],
    },
    {
      path: '/gallery',
      name: 'gallery',
      icon: ['fas', 'images'],
    },
    {
      path: '/contact',
      name: 'contact',
      icon: ['fas', 'envelope'],
    },
  ]

  get isTransition(): boolean {
      return this.$store.getters.isTransition
  }
}
